import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa78d18e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-theme"];
const _hoisted_2 = /*#__PURE__*/ _createStaticVNode("<svg class=\"Icon size-em text-32 fill-current\" viewBox=\"0 0 24 24\" data-v-aa78d18e><path d=\"M3.504 10.61c-.022-.53.04-.721.223-.83.654-.427 1.346-.8 2.067-1.114.09-.03.28-.086.277.004.055 1.023-.106 3.232-.082 3.873l.026 4.43c.002.875-.085 1.364-.053 1.706a.573.573 0 0 1-.062.286.537.537 0 0 1-.194.21c-.6.469-.87.343-1.826.329-.079.063-.207.16-.27.129-.064-.032-.072-.195-.073-.306-.022-1.415.124-3.125.015-4.559-.11-1.434.025-2.627-.048-4.159Z\" data-v-aa78d18e></path><path d=\"M8.015 12.91c-.022-.53.04-.72.223-.829.654-.427 1.346-.8 2.067-1.114.09-.03.28-.086.277.004.054 1.023-.186 1.74-.163 2.381l-.013 3.684c.002.875-.125.617-.094.96a.572.572 0 0 1-.062.285.537.537 0 0 1-.194.21c-.599.47-.869.344-1.825.33-.08.063-.208.16-.272.128-.063-.032-.07-.195-.072-.306-.022-1.414.205-1.632.096-3.066-.11-1.434.105-1.135.032-2.667Z\" data-v-aa78d18e></path><path d=\"M13.149 6.869c-.01-.53.055-.72.241-.824a14.069 14.069 0 0 1 2.093-1.065c.091-.028.282-.08.277.01.03 1.024-.114 5.47-.106 6.111l-.078 4.43c-.018.874-.072 2.854-.048 3.197a.573.573 0 0 1-.07.284.537.537 0 0 1-.198.206c-.61.455-.877.323-1.833.286-.08.061-.211.155-.274.122-.063-.033-.066-.197-.065-.308.011-1.414.153-4.614.078-6.05-.076-1.436.02-4.866-.017-6.4Z\" data-v-aa78d18e></path><path d=\"M17.701 10.61c-.023-.53.039-.721.222-.83.655-.427 1.346-.8 2.068-1.114.09-.03.28-.086.276.004.055 1.023-.105 3.232-.082 3.873l.027 4.43c.002.875-.085 1.364-.054 1.706a.572.572 0 0 1-.062.286.537.537 0 0 1-.194.21c-.599.469-.869.343-1.825.329-.079.063-.208.16-.271.129-.064-.032-.071-.195-.073-.306-.022-1.415.125-3.125.015-4.559-.109-1.434.026-2.627-.047-4.159Z\" data-v-aa78d18e></path></svg>", 1);
const _hoisted_3 = { class: "grid *:row-start-1 *:col-start-1 text-left" };
import { onBeforeUnmount, ref, watch } from "vue";
import useGSAP from "@/composables/useGSAP";
import useAudioManager from "@/composables/useAudioManager";
import { setFPS } from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppSoundToggle',
    props: {
        theme: { default: "dark" }
    },
    setup(__props) {
        const props = __props;
        const gsap = useGSAP();
        const frames = setFPS(60);
        const { muted: isMuted } = useAudioManager();
        const root = ref(null);
        const isHover = ref(false);
        function toggle() {
            isMuted.value = !isMuted.value;
        }
        let tl;
        watch(isMuted, (isMuted) => {
            if (!root.value)
                return;
            const $ = gsap.utils.selector(root.value);
            const bars = $(".Icon path");
            gsap.set(bars, { transformOrigin: "0 100% 0" });
            tl === null || tl === void 0 ? void 0 : tl.kill();
            tl = gsap.timeline();
            if (isMuted) {
                const scales = [0.45, 0.625, 0.34, 0.45];
                bars.forEach((bar, i) => {
                    tl.to(bar, {
                        scaleY: scales[i],
                        duration: frames(20),
                        ease: "ease.out"
                    }, 0);
                });
            }
            else {
                const barsKeyframes = [
                    { "25%": { scaleY: 1.1 }, "58.333333%": { scaleY: 0.7 }, "100%": { scaleY: 1 } },
                    { "33.333333%": { scaleY: 0.7 }, "66.666667%": { scaleY: 1.2 }, "100%": { scaleY: 1 } },
                    { "33.333333%": { scaleY: 1.2 }, "75%": { scaleY: 0.9 }, "100%": { scaleY: 1 } },
                    { "25%": { scaleY: 1.1 }, "66.666667%": { scaleY: 0.9 }, "100%": { scaleY: 1 } },
                ];
                const duration = frames(120);
                const ease = "ease.inOut";
                bars.forEach((bar, i) => {
                    const keyframes = Object.assign(Object.assign({}, barsKeyframes[i]), { easeEach: ease });
                    tl.to(bar, {
                        keyframes,
                        duration,
                        ease: "none",
                        repeat: -1,
                        repeatRefresh: true
                    }, 0);
                });
            }
        });
        onBeforeUnmount(() => {
            tl === null || tl === void 0 ? void 0 : tl.kill();
        });
        return (_ctx, _cache) => {
            const _component_UIBtn = _resolveComponent("UIBtn");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return _withDirectives((_openBlock(), _createElementBlock("button", {
                ref_key: "root",
                ref: root,
                type: "button",
                class: "AppSoundToggle inline-flex items-center gap-8",
                "data-theme": _ctx.theme,
                onMouseenter: _cache[0] || (_cache[0] = ($event) => (isHover.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event) => (isHover.value = false)),
                onClick: toggle
            }, [
                _hoisted_2,
                _createVNode(_component_UIBtn, {
                    as: "span",
                    class: _normalizeClass(["hidden lg:inline-block pointer-events-none", { hover: isHover.value }]),
                    theme: _ctx.theme,
                    sound: false
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, [
                            _createElementVNode("span", {
                                class: _normalizeClass({ 'invisible': _unref(isMuted) })
                            }, _toDisplayString(_ctx.$t("global.sound.on")), 3),
                            _createElementVNode("span", {
                                class: _normalizeClass({ 'invisible': !_unref(isMuted) })
                            }, _toDisplayString(_ctx.$t("global.sound.off")), 3)
                        ])
                    ]),
                    _: 1
                }, 8, ["class", "theme"])
            ], 40, _hoisted_1)), [
                [
                    _directive_cursor,
                    void 0,
                    void 0,
                    { hover: true }
                ],
                [
                    _directive_sound,
                    void 0,
                    void 0,
                    { hover: true }
                ]
            ]);
        };
    }
});
